'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["isDragging", "collected"];
import { findDOMNode } from 'react-dom';
import { DragLayer } from 'react-dnd';
import { calculateOffsetOnDragComponent } from 'layout-dnd-utils/dom/offset';
import { jsx as _jsx } from "react/jsx-runtime";
const getLayerStyles = (isDragging, zIndex = 1) => ({
  position: 'fixed',
  pointerEvents: 'none',
  zIndex,
  left: 0,
  top: 0,
  width: isDragging ? '100%' : 0,
  height: isDragging ? '100%' : 0,
  opacity: isDragging ? 1 : 0
});

// https://github.com/react-dnd/react-dnd/issues/592#issuecomment-547010516

export default function PerformantDragLayer(collect, options) {
  return function decorateLayer(DecoratedComponent) {
    let dragLayerRef = null;
    let offsetOnDragComponent = null;
    let prevWasDragging = null;
    const getComputedOffsetsOnDragItem = monitor => {
      if (!offsetOnDragComponent && monitor) {
        const {
          dragPreviewHeightPx,
          dragPreviewWidthPx
        } = options;
        const item = monitor.getItem();
        const newOffset = calculateOffsetOnDragComponent({
          dragPreviewHeightPx,
          dragPreviewWidthPx,
          /* eslint-disable-next-line react/no-find-dom-node */
          itemBeingDragged: findDOMNode(item.component),
          monitor
        });
        if (!newOffset) {
          return null;
        }
        offsetOnDragComponent = newOffset;
      }
      return offsetOnDragComponent;
    };
    const dragLayerCollector = monitor => {
      const isDragging = monitor.isDragging();
      const item = monitor.getItem();

      // Reset saved offsetOnDragComponent state every new drag
      if (prevWasDragging === true && isDragging === false) {
        offsetOnDragComponent = null;
      }
      prevWasDragging = isDragging;
      if (dragLayerRef && item) {
        // const offset =
        //   monitor.getSourceClientOffset() || monitor.getInitialClientOffset();
        const offset = monitor.getClientOffset();
        const computedOffsets = getComputedOffsetsOnDragItem(monitor);
        if (offset && computedOffsets) {
          dragLayerRef.style['transform'] = `translate(${offset.x + computedOffsets.x}px, ${offset.y + computedOffsets.y}px)`;
        } else if (offset) {
          dragLayerRef.style['transform'] = `translate(${offset.x}px, ${offset.y}px)`;
        } else {
          dragLayerRef.style['display'] = `none`;
        }
      }
      return {
        collected: collect(monitor),
        item,
        isDragging
      };
    };
    const DragLayerContainerNew = DragLayer(dragLayerCollector)(props => {
      if (!props.isDragging) {
        return null;
      }
      const {
          isDragging,
          collected
        } = props,
        otherProps = _objectWithoutPropertiesLoose(props, _excluded);
      return (
        /*#__PURE__*/
        // @bend-expect trellis-tokenized
        _jsx("div", {
          style: getLayerStyles(isDragging, options.zIndex),
          children: /*#__PURE__*/_jsx("div", {
            ref: ref => dragLayerRef = ref,
            children: /*#__PURE__*/_jsx(DecoratedComponent, Object.assign({}, otherProps, collected))
          })
        })
      );
    });
    const displayName = DecoratedComponent.displayName || DecoratedComponent.name || 'Component';
    DragLayerContainerNew.DecoratedComponent = DecoratedComponent;
    DragLayerContainerNew.displayName = `DragLayer(${displayName})`;

    // Give outside access to last value calculated by getComputedOffsetsOnDragItem (used by Email D&D)
    DragLayerContainerNew.prototype.getComputedOffsetsOnDragItem = getComputedOffsetsOnDragItem;
    return DragLayerContainerNew;
  };
}